import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ModalForm from './ModalForm';
import { Tag } from 'lucide-react';

const getRandomProducts = (products, count = 6) => {
  const shuffled = [...products].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

const CatalogSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [randomProducts, setRandomProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('/api/products/');
        const products = response.data;
        setRandomProducts(getRandomProducts(products, 6));
      } catch (error) {
        console.error('Ошибка загрузки продуктов:', error);
      }
    };

    fetchProducts();
  }, []);

  const handleCardClick = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <section id="catalog" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h3 className="text-3xl font-bold text-center mb-12 text-black">
          Каталог продукции
        </h3>

        <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {randomProducts.map((product) => (
            <div
              key={product.id}
              onClick={() => handleCardClick(product)}
              className="bg-white rounded-2xl border border-gray-200 p-5 shadow hover:shadow-md transition cursor-pointer"
            >
              {product.category?.image && (
                <img
                  src={product.category.image}
                  alt={product.category.name}
                  className="w-full h-48 object-cover rounded-xl mb-4"
                />
              )}

              <h4 className="text-xl font-semibold text-gray-900 mb-2">{product.name}</h4>

              {product.size && (
                <p className="text-sm text-gray-500 mb-2">Размер: {product.size}</p>
              )}

              {product.description && (
                <p className="text-sm text-gray-600 mb-4">{product.description}</p>
              )}

              <div className="space-y-1">
                {product.currentPrice ? (
                  <div className="flex items-center space-x-2">
                    <span className="text-lg font-bold text-red-600">
                      {product.currentPrice} ₽
                    </span>
                    {product.oldPrice && (
                      <>
                        <span className="text-sm text-gray-400 line-through">
                          {product.oldPrice} ₽
                        </span>
                        <Tag size={14} className="text-red-600 ml-1" />
                      </>
                    )}
                  </div>
                ) : (
                  <>
                    {product.price_per_meter && (
                      <div className="text-sm text-gray-800">
                        Цена за м.п:{' '}
                        <span className="text-red-600 font-bold">
                          {product.price_per_meter} ₽
                        </span>
                      </div>
                    )}
                    {product.price_per_ton && (
                      <div className="text-sm text-gray-800">
                        Цена за т:{' '}
                        <span className="text-red-600 font-bold">
                          {product.price_per_ton} ₽
                        </span>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/catalog"
            className="inline-block px-6 py-3 bg-red-500 text-white font-bold rounded-lg shadow-md hover:bg-red-600 transition-all duration-300"
          >
            Перейти в каталог
          </a>
        </div>
      </div>

      {isModalOpen && (
        <ModalForm
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          product={selectedProduct}
        />
      )}
    </section>
  );
};

export default CatalogSection;
